import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { ButtonModule } from "primeng/button";
import { map, Observable } from "rxjs";
import { AuthSelectors } from "src/app/modules/auth/ngrx/auth.selectors.types";
import { AppState } from "src/app/ngrx/app.reducer";
import { CopyrightComponent } from "src/app/shared/components/copyright/copyright.component";
import { environment } from "src/environments/environment";
import { GeneralDialogComponent } from "../general-dialog/general-dialog.component";

@Component({
  selector: "rs-about-dialog",
  imports: [ButtonModule, CopyrightComponent, AsyncPipe, GeneralDialogComponent],
  standalone: true,
  templateUrl: "./about-dialog.component.html"
})
export class AboutDialogComponent {
  displayAboutDialog = false;

  get loggedInUsername(): Observable<string | undefined> {
    return this.store.select(AuthSelectors.activeUser);
  }

  get customerFacingVersion(): string {
    return environment.customerFacingVersion;
  }

  get logos() {
    return environment.logos;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>
  ) {}

  get shouldDisplay$(): Observable<boolean> {
    return this.route.queryParams.pipe(map((params) => params["showAbout"] === "true"));
  }

  closeAboutDialog(): void {
    this.displayAboutDialog = false;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { showAbout: null },
      queryParamsHandling: "merge"
    });
  }
}
